export default __webpack_public_path__ + "6611b48e32706eb1f1780c1e612f346a.png";